module.exports = __webpack_public_path__ + "img/thumb_18.6c22ea2d.jpg";